<template>
  <div class="virtual-account-container" @click.stop>
    <div
      class="current-type-container j-open-card-list"
      pointClass="j-open-card-list"
      @click="handleSelectCard"
    >
      <span class="type-category">
        <template v-if="curCard.KEY_VALUE">{{
          curCard.KEY_VALUE_DESC
        }}</template>
        <template v-else>{{ languages.quickcard_use_new_card }}</template>
      </span>
      <Icon class="selected-type-icon" name="down"></Icon>
    </div>
    <div class="quick-card-tips-content">
      <p>{{ languages.quickcard_tips }}</p>
    </div>
    <quick-pay-card-selecter
      v-if="showPayCardSelecter"
      @closeSelecter="showPayCardSelecter = false"
      :curPayType="curPayType"
      :showChildSelector="showPayCardSelecter"
      :cardInfos="cardInfos"
      :curCard="curCard"
      :confirmDeleteCard="confirmDeleteCard"
      :languages="languages"
      @selectCard="selectCard"
      @deleteCard="handleDeletePopup"
      style="z-index: 6"
    ></quick-pay-card-selecter>
    <PopupWindow
      class="delete-card-popup"
      @onCancel="cancelDelete"
      @onConfirm="handleDelete"
      type="confirm"
      v-if="showPopup"
      :languages="languages"
      :content="languages.quickcard_popup_tip"
      :title="languages.quickcard_confirm_delete"
    ></PopupWindow>
  </div>
</template>

<script>
import QuickPayCardSelecter from '@components/officialTopup/paytype/QuickPayCardSelecter';
import { DELETE_CARD } from '@store/officialTopup';
import { popupType, showPopup } from '@plugins/biPoint/_configWebstoreV3';
export default {
  name: 'QuickPayCard',
  props: {
    curCard: {
      require: true
    },
    cardInfos: {
      require: true
    },
    curPayType: {
      require: true
    },
    languages: {
      require: true
    }
  },
  data() {
    return {
      showPayCardSelecter: false,
      showPopup: false,
      canPost: true,
      confirmDeleteCard: false,
      deleteCardKey: '' //要删除的卡
    };
  },
  methods: {
    handleDelete() {
      this.showPopup = false;
      if (!this.canPost) {
        return;
      }
      this.$store
        .dispatch(DELETE_CARD, {
          f_pay_type: this.curPayType?.f_pay_type,
          pay_type: this.curPayType?.pay_type,
          currency: this.curPayType?.currency,
          key_value: this.deleteCardKey
        })
        .then(_res => {
          this.canPost = true;
          this.showPopup = false;
          this.$emit('deleteCurPayTypeCard', this.deleteCardKey);
        })
        .catch(err => {
          this.canPost = true;
          this.$emit('showError', err);
        });
    },
    cancelDelete() {
      this.showPopup = false;
    },
    selectCard(card) {
      this.$emit('selectCard', card);
      this.$nextTick(() => {
        this.showPayCardSelecter = false;
      });
    },
    handleDeletePopup(keyValue) {
      this.deleteCardKey = keyValue;
      this.showPopup = true;
    },
    handleSelectCard() {
      this.showPayCardSelecter = true;
      showPopup(popupType.quickPayCardSelectPopup);
    }
  },
  components: {
    QuickPayCardSelecter
  }
};
</script>

<style lang="scss" scoped>
.quick-card-tips-content {
  margin-top: 20px;
  font-size: 22px;
  color: #999999;
  line-height: 1.5;
}
.delete-card-popup {
  z-index: 1003 !important;
  ::v-deep .tips-content {
    display: inline-block;
    padding: 0;
  }
}
@media screen and (orientation: landscape) {
  .quick-card-tips-content {
    font-size: 16px;
  }
}
</style>
